export default {
    path: 'statement',
    component: () => import(/* webpackChunkName: "common-list" */ '@/pages/common/CommonList'),
    meta: {title:'结算单记录'}
}